import { Injectable } from '@angular/core';
import { CommonEnum, StatusCode } from '../_enums/Common';
import { PermissionType } from '../_enums/permissionType';
import { CommonService } from './app.common.service';
import { SecurityRoleItems } from '../_enums/securityRoleItems';
@Injectable({
  providedIn: 'root'
})
export class RoleAccessService {
  constructor(private common: CommonService) { }
  // ...
  public HasAccess(roleItem: string, accessType?: string | null | undefined): boolean {

    if (accessType == undefined || accessType == null || accessType == PermissionType.Accesss)
      accessType = "Item";
    if (roleItem == SecurityRoleItems.FeatureMyJobs) {
      try {
        let permissions = this.common.GetPermissions();
        return permissions.filter((x: { securityRoleItem: string; }) => x.securityRoleItem == roleItem)[0]['allow' + accessType];
      } catch (e) {
        return false;
      }
    } else {
      try {
        let permissions = this.common.GetPermissions();
        // return true;
        return permissions.filter((x: { securityRoleItem: string; }) => x.securityRoleItem == roleItem)[0]["allow" + accessType] == CommonEnum.Yes

      } catch (e) {
        return false;
      }
     }

  }
  public HasMainMenuAccess(mainMenu: string): boolean {


    try {
      let permissions = this.common.GetPermissions();
      // return true;
      let anyItem = permissions.filter((x: { mainMenu: string; allowItem: string; }) => x.mainMenu == mainMenu && x.allowItem == CommonEnum.Yes)[0];
      return anyItem != null ? true : false;


    } catch (e) {
      return false;
    }

  }
  public HasSubMenuAccess(subMenu: string): boolean {


    try {
      let permissions = this.common.GetPermissions();
      // return true;
      let anyItem = permissions.filter((x: { subMenu: string; allowItem: string; }) => x.subMenu == subMenu && x.allowItem == CommonEnum.Yes)[0];
      return anyItem != null ? true : false;


    } catch (e) {
      return false;
    }

  }
  public HasWhiteLabelAccess(roleItem: string): boolean {

    try {
      let permissions = this.common.GetWhiteLabelPermissions();
      let hasPermission = permissions.filter((x: { key: string; }) => x.key == roleItem);
      if (hasPermission.length > 0) {
        return hasPermission[0]['value'] == CommonEnum.Allow;
      } else {
        return true;
      }

    } catch (e) {
      return false;
    }

  }


  public IsPermissionsExists(): boolean {
    try {
      let permissions = this.common.GetPermissions();
      if (permissions != null) {
        return true;
      } else {
        return false;
      }

    } catch (e) {
      return false;
    }

  }
  // This method is called once and a list of permissions is stored in the permissions property
  public initializePermissions() {
    return new Promise((resolve, reject) => {
      // Call API to retrieve the list of actions this user is permitted to perform. (Details not provided here.)
      // In this case, the method returns a Promise, but it could have been implemented as an Observable
      let that = this;
      this.common.GetData(this.common.ApiUrls.Login.GetOwnSecurityRoleDetail).then(function (data) {

        if (data.status == StatusCode.OK) {
          that.common.SetLocalStorage('jt_permissions', JSON.stringify(data.resultData.securityRoleDetail));
          that.common.SetLocalStorage('jt_user_info', JSON.stringify(data.resultData.user));
          resolve(true);
        } else {
          reject(false);
        }
      });
    });
  }
  public MenuAccess(roleItem: string, accessType: string): boolean {

    if (accessType == undefined || accessType == null || accessType == PermissionType.Accesss) {
      accessType = 'Item';
    }
    let permissions = this.common.GetPermissions();
    try {
      // if (roleItem == "allowSettingsSs")
      return permissions.filter((x: { securityRoleItem: string; }) => x.securityRoleItem == roleItem)[0]['allow' + accessType] == CommonEnum.Yes;
      // return permissions.filter(x => x.securityRoleItem == CommonEnum.Yes)[0]
    } catch (e) {
      return false;
    }


  }
}
